import { render, staticRenderFns } from "./BranchMenuComponent.vue?vue&type=template&id=604b16e6&"
import script from "./BranchMenuComponent.vue?vue&type=script&lang=js&"
export * from "./BranchMenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports